import React, { Component } from 'react';
import Header from '../components/PartnerWithUs/Header';
import ContactFormMobile from '../components/PartnerWithUs/ContactFormMobile';
import DishCardPreview from '../components/PartnerWithUs/DishCardPreview';
import RestaurantCardPreview from '../components/PartnerWithUs/RestaurantCardPreview';
import { withRouter } from 'react-router';

// Initial Landing Page
class PartnerWithUs extends Component {
  
  constructor(){
    super();
    this.toggleAuthModal = this.toggleAuthModal.bind(this);
    this.setActiveForm = this.setActiveForm.bind(this);
    this.closeAuthModal = this.closeAuthModal.bind(this);
    this.toggleDishCardPreview = this.toggleDishCardPreview.bind(this);
    this.toggleImageHover = this.toggleImageHover.bind(this);
    this.closeDishCardPreviewModal = this.closeDishCardPreviewModal.bind(this);
    this.toggleRestaurantCardPreview = this.toggleRestaurantCardPreview.bind(this);
    this.closeRestaurantCardPreviewModal = this.closeRestaurantCardPreviewModal.bind(this);
    this.state = {
      authModalOpen: false,
      activeForm: "",
      isMobileScreen: false,
      dish: {},
      restaurant: {},
      dishPreviewOpen: false,
      restaurantPreviewOpen: false,
      descriptionOverlayStyle: {display: 'none'}
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    let screen_width = window.innerWidth;
    if(screen_width < 500) {
        this.setState({ isMobileScreen: true });
    } else {
        this.setState({ isMobileScreen: false });
    }
  }

  preventDefault(e) {
    e.preventDefault();
  }

  preventDefaultForScrollKeys(e) {
    var keys = {9: 1, 38: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1};
    if (keys[e.keyCode]) {
      e.preventDefault();
      return false;
    }
  }

  disableScrolling(wheelOpt, wheelEvent) {
    window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
    window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }

  enableScrolling(wheelOpt, wheelEvent) {
    window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    window.removeEventListener(wheelEvent, this.preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', this.preventDefault, wheelOpt);
    window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }

  componentDidUpdate() {   
    try {
      var supportsPassive = false;
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; return(supportsPassive) } 
      }));
    } catch(e) {}
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    if(this.state.authModalOpen && !this.state.isMobileScreen){
      this.disableScrolling(wheelOpt, wheelEvent);
    } else {
      this.enableScrolling(wheelOpt, wheelEvent);
    }
  }

  componentWillUnmount(){
    try {
      var supportsPassive = false;
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; return(supportsPassive) } 
      }));
    } catch(e) {}
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    this.enableScrolling(wheelOpt, wheelEvent);
  }

  toggleAuthModal() {
    this.setState({
      authModalOpen: true
    })
  }

  setActiveForm(form){
    if (this.state.activeForm !== form){
      this.setState({
        activeForm: form
      })
    }
  }

  closeAuthModal(){
    if (this.state.authModalOpen){
      this.setState({
        authModalOpen: false
      })
    }
  }

  toggleDishCardPreview(dish){
    this.setState({
      dishPreviewOpen: true,
      dish: dish
    })
  }

  toggleRestaurantCardPreview(restaurant){
    this.setState({
      restaurantPreviewOpen: true,
      restaurant: restaurant
    })
  }

  toggleImageHover(index){
    let dish = this.state.dish;
    if (dish.imageHover){
      this.setState({
        descriptionOverlayStyle: {display: 'none'}
      })
    } else {
      this.setState({
        descriptionOverlayStyle: {display: 'block'}
      })
    }
    dish.imageHover = !this.state.dish.imageHover;
    this.setState({
      dish: dish
    });
  }

  closeRestaurantCardPreviewModal(){
    this.setState({
      restaurantPreviewOpen: false
    })
  }

  closeDishCardPreviewModal(){
    this.setState({
      dishPreviewOpen: false
    })
  }

  render() {
    return (
      <div>
        <Header
          toggleAuthModal={this.toggleAuthModal}
          setActiveForm={this.setActiveForm}
          authModalOpen={this.state.authModalOpen}
          toggleDishCardPreview={this.toggleDishCardPreview}
          toggleRestaurantCardPreview={this.toggleRestaurantCardPreview}
        />
        <ContactFormMobile
          authModalOpen={this.state.authModalOpen}
          toggleDishCardPreview={this.toggleDishCardPreview}
          toggleRestaurantCardPreview={this.toggleRestaurantCardPreview}
        />
        <DishCardPreview
          dishPreviewOpen={this.state.dishPreviewOpen}
          toggleImageHover={this.toggleImageHover}
          dish={this.state.dish}
          descriptionOverlayStyle={this.state.descriptionOverlayStyle}
          closeDishCardPreviewModal={this.closeDishCardPreviewModal}
        />
        <RestaurantCardPreview
          restaurantPreviewOpen={this.state.restaurantPreviewOpen}
          restaurant={this.state.restaurant}
          closeRestaurantCardPreviewModal={this.closeRestaurantCardPreviewModal}
        />
      </div>
    );
  }
}

export default withRouter(PartnerWithUs);
